import { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { GET_EXHIBITORS } from '@general/graphql/exhibitors.graph';

const useExhibitors = eventCode => {
    const { data } = useQuery(GET_EXHIBITORS, { variables: { eventCode } });
    const [exhibitors, setExhibitors] = useState(null);

    useEffect(() => {
        if (!data?.exhibitors) {
            return;
        }

        setExhibitors(data.exhibitors);
    }, [data, exhibitors]);

    return exhibitors;
};

export default useExhibitors;
